import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface Industry {
  id: string;
  name: string;
  categories: string[];
  created_at: string;
}

export function useIndustries() {
  const [industries, setIndustries] = useState<Industry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchIndustries();
  }, []);

  const fetchIndustries = async () => {
    try {
      const { data, error } = await supabase
        .from('industries')
        .select('*')
        .order('name', { ascending: true });

      if (error) throw error;
      setIndustries(data || []);
    } catch (err) {
      console.error('Error fetching industries:', err);
    } finally {
      setLoading(false);
    }
  };

  const getCategoriesForIndustry = (industryName: string): string[] => {
    const industry = industries.find(i => i.name === industryName);
    return industry?.categories || [];
  };

  return {
    industries,
    loading,
    getCategoriesForIndustry,
    refetch: fetchIndustries,
  };
}
